const bisForms = [...document.querySelectorAll('.js-reminder')];

if (bisForms) {
    bisForms.map(bisForm => {
        bisForm.addEventListener('submit', async e => {
            e.preventDefault();

            const email = bisForm.querySelector('input[name="email"]');
            const variantId = bisForm.querySelector('.js-product-variant').value;
            const languageCode = bisForm.dataset.lang;

            const options = {
                method: 'POST',
                headers: {
                    accept: 'application/json',
                    revision: '2024-07-15',
                    'content-type': 'application/json'
                },
                body: JSON.stringify({
                    data: {
                        type: 'back-in-stock-subscription',
                        attributes: {
                            profile: {
                                data: {
                                    type: 'profile',
                                    attributes: {
                                        email: `${email.value}`
                                    }
                                }
                            },
                            channels: ["EMAIL"]
                        },
                        relationships: {
                            variant: {
                                data: {
                                    type: 'catalog-variant',
                                    id: `$shopify:::$default:::${variantId}`
                                }
                            }
                        }
                    }
                })
            };

            fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=T3UXXf', options)
                .then(response => response)
                .then(response => {
                    if (response.ok === true) {
                        var _learnq = window._learnq || [];
                        _learnq.push(['identify', {
                            '$email': email.value,
                            'Language': languageCode
                        }]);

                        email.value = '';
                        email.parentElement.parentElement.style.display = 'none';
                        bisForm.querySelector('.js-bis-success').classList.remove('d-none');
                    } else {
                        console.log('BIS failed');
                        bisForm.querySelector('.js-bis-fail').classList.remove('d-none');
                    }
                })
                .catch(err => console.error(err));
        });
    });
}
